import { z } from "zod";
import {
  YEAR,
  MONTH,
  SCHOOL_NAME,
  GEO_REGION_ID,
  CRM_RH,
  CRM_RM, 
  INVOICE_OWNER,
  STATUS,
  DUE_DAYS,
  INVOICE_GENERATION_DATE,
} from "../consts";

export const schema = z.object({
  [YEAR]: z.union([z.string(), z.number()]).optional(),
  [MONTH]: z.union([z.string(), z.number()]).optional(),
  [SCHOOL_NAME]: z.string().optional(),
  [GEO_REGION_ID]: z.string().optional(),
  [CRM_RH]: z.string().optional(),
  [CRM_RM]: z.string().optional(),
  [INVOICE_OWNER]: z.string().optional(),
  [STATUS]: z.string().optional(),
  [DUE_DAYS]: z.union([z.string(), z.number()]).optional(),
  [INVOICE_GENERATION_DATE]: z.string().optional(), 
 
});

export type formValues = z.infer<typeof schema>;
